
export const getButtonByKind = (kind?: string, size?: string) => {

  switch (kind) {
    default:
    case 'primary': {
      return `bg-brand-baseBlue hover:bg-brand-baseBlue-hover text-white disabled:opacity-50
        ${size === 'small' ? ' text-sm' : ''}`;
    }
    case 'secondary': {
      return `bg-base-ghostWhite text-base-blue disabled:opacity-50
        ${size === 'small' ? ' text-sm' : ''}`;
    }
    case 'tertiary': {
      return `bg-transparent text-base-blue disabled:opacity-50
        ${size === 'small' ? ' text-sm' : ''}`;
    }
    case 'quaternary': {
      return `bg-brand-lightBlue3 text-brand-darkBlue3 disabled:opacity-50
        ${size === 'small' ? ' text-sm' : ''}`;
    }
    case 'danger': {
      return `bg-system-error text-white disabled:opacity-50
        ${size === 'small' ? ' text-sm' : ''}`;
    }
  }
};
